function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'midnight-blue': 'rgb(0, 51, 102)','khaki-green': 'rgb(153, 204, 102)','pebble': 'rgb(204, 204, 204)','black-gold': 'rgb(51, 51, 0)','galactic': 'rgb(0, 51, 153)','moss-metallic': 'rgb(0, 102, 0)','metallic-aubergine': 'rgb(97, 75, 124)','gloss-black': 'rgb(0, 0, 0)','midnight-blue': 'rgb(51, 51, 153)','dark-plum': 'rgb(90, 36, 87)','titanium': 'rgb(204, 204, 153)','black-bronze': 'rgb(102, 51, 0)','deep-purple': 'rgb(153, 0, 255)','graphite-grey': 'rgb(124, 114, 112)','silver-mist': 'rgb(217, 217, 217)','dark-heather': 'rgb(57, 57, 57)','blue-cyan': 'rgb(3, 121, 204)','camouflage': 'rgb(120, 134, 107)','pepper-red': 'rgb(179, 18, 56)','cortado': 'rgb(192, 140, 106)','matcha': 'rgb(167, 166, 133)','neon-pink': 'rgb(255, 38, 104)','olive-green': 'rgb(124, 136, 88)','red-clay': 'rgb(176, 122, 85)','black-olive-green': 'rgb(85, 107, 47)','mallard-blue': 'rgb(33, 76, 79)','heather-grey': 'rgb(182, 182, 180)','pea-green': 'rgb(142, 171, 18)','mist-peak-blue': 'rgb(91, 172, 195)','sunset-yellow': 'rgb(255, 201, 34)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
